import io from 'socket.io-client';

const socket = io.connect(BACKEND_URL.slice(0, -4));
export default socket;
